import Vue from 'vue';
import store from 'store';
import { i18n } from 'lib/i18n.js';
import { decode } from 'utils/general';
import bus from 'lib/bus';
import { trackEvent } from '../../assets/js/lib/tracking';
import { htmlDecode } from '../../assets/js/utils/general';

export default (el) =>
  new Vue({
    el,
    store,
    i18n,
    name: 'Bundle Builder',
    components: {
      'bundle-builder-step': () =>
        import('../bundle-builder/bundle-builder-step.vue'),
      'bundle-builder-bar': () =>
        import('../bundle-builder-bar/bundle-builder-bar.vue'),
      'bundle-builder-gallery': () =>
        import('../bundle-builder-gallery/bundle-builder-gallery.vue'),
    },
    data() {
      return {
        selectedItems: [],
        errorMessage: false,
        deletingIndex: false,
        discount: 0,
        bundleProduct: null,
      };
    },
    mounted() {
      this.bundleProduct = JSON.parse(decode(this.$el.dataset.product));
      this.discount = Number(this.$el.dataset.discount);
      bus.$on('bb-item-added', this.setSelectedItem);
      bus.$on('bb-delete-all', this.deletePreviouslySelectedItems);
      bus.$on('show-error-message', this.showErrorMessage);
      bus.$on('bb-clear-items', this.clearSelection);
    },
    computed: {
      stepsDecoded() {
        const stepsData = JSON.parse(decode(this.$el.dataset.steps));
        return stepsData.map((p) => p);
      },
      bundleSize() {
        const itemsSize = this.stepsDecoded.reduce((total, step) => {
          return (total += Number(step.limit));
        }, 0);

        return itemsSize;
      },
    },
    methods: {
      async setSelectedItem(product) {
        const step = this.stepsDecoded.findIndex(step => step.products.findIndex(p => p.id == product.id) > -1);
        const existingItem = this.selectedItems.findIndex(
          (item) => item.id === product.id,
        );
        const itemToReplace = this.selectedItems.findIndex((item) => {
          return (
            item.title.split(window.__GLOBAL__.productDelimiter)[0] ===
            htmlDecode(product.title.split(window.__GLOBAL__.productDelimiter)[0])
          );
        });

        if (existingItem > -1) {
          this.deletingIndex = existingItem;

          setTimeout(() => {
            this.deletingIndex = false;
            this.selectedItems.splice(existingItem, 1);
          }, 250);

          trackEvent({
            event: 'remove_from_bundle',
            site_section: window.__GLOBAL__.siteSection,
            component_name: 'Bundle Builder Quickview',
            item_name: htmlDecode(product.title),
            item_id: product.id,
            currency: window.Shopify.currency.active,
            bundle_id: this.bundleProduct.id,
            bundle_name: this.bundleProduct.title,
            value: product.price / 100,
            price: product.compare_at_price ? parseInt(product.compare_at_price, 10) / 100 : parseInt(product.price, 10) / 100,
            item_list_id: `bundle-step-${step + 1}`,
            item_list_name: this.stepsDecoded[step].title
          })
        } else if (itemToReplace > -1) {
          this.deletingIndex = existingItem;

          const deleteItem = {...this.selectedItems[existingItem]};
          
          setTimeout(() => {
            this.deletingIndex = false;
            this.selectedItems.splice(existingItem, 1);
            product.step = step;
            this.selectedItems.push(product);
          }, 250);

          trackEvent({
            event: 'remove_from_bundle',
            site_section: window.__GLOBAL__.siteSection,
            component_name: 'Bundle Builder Quickview',
            item_name: htmlDecode(deleteItem.title),
            item_id: deleteItem.id,
            currency: window.Shopify.currency.active,
            bundle_id: this.bundleProduct.id,
            bundle_name: this.bundleProduct.title,
            value: deleteItem.price / 100,
            price: deleteItem.compare_at_price ? parseInt(deleteItem.compare_at_price, 10) / 100 : parseInt(deleteItem.price, 10) / 100,
            item_list_id: `bundle-step-${step + 1}`,
            item_list_name: this.stepsDecoded[step].title
          })

          trackEvent({
            event: 'add_to_bundle',
            site_section: window.__GLOBAL__.siteSection,
            component_name: 'Bundle Builder Quickview',
            step_number: step + 1,
            item_name: htmlDecode(product.title),
            item_id: product.id,
            currency: window.Shopify.currency.active,
            bundle_id: this.bundleProduct.id,
            bundle_name: htmlDecode(this.bundleProduct.title),
            price: product.compare_at_price ? parseInt(product.compare_at_price, 10) / 100 : parseInt(product.price, 10) / 100,
            value: product.price / 100,
            index: product.index + 1, 
            item_list_id: `bundle-step-${step + 1}`,
            item_list_name: this.stepsDecoded[step].title
          })          
        } else {
          if (product.optionNames.includes('Size')) {
            product.hasSizes = true;
            const imageSource = product.variants.find((variant) =>
              variant.bundleBuilderProductIds?.includes(this.bundleProduct.id),
            ) || product.variants[0];
            product.featuredImage = imageSource.image.src;
          }

          product.step = step;
          this.selectedItems.push(product);

          trackEvent({
            event: 'add_to_bundle',
            site_section: window.__GLOBAL__.siteSection,
            component_name: 'Bundle Builder Quickview',
            step_number: step + 1,
            item_name: htmlDecode(product.title),
            item_id: product.id,
            currency: window.Shopify.currency.active,
            bundle_id: this.bundleProduct.id,
            bundle_name: htmlDecode(this.bundleProduct.title),
            price: product.compare_at_price ? parseInt(product.compare_at_price, 10) / 100 : parseInt(product.price, 10) / 100,
            value: product.price / 100,
            index: product.index + 1, 
            item_list_id: `bundle-step-${step + 1}`,
            item_list_name: this.stepsDecoded[step].title
          })
        }

        
      },
      deletePreviouslySelectedItems(step) {
        const products = this.stepsDecoded[step].products;

        const productsIds = products.map((product) => product.id);
        productsIds.forEach((id) => {
          const existingItem = this.selectedItems.findIndex(
            (item) => item.id === id,
          );
          if (existingItem > -1 && this.selectedItems[existingItem].step == step) {
            const deleteItem = {...this.selectedItems[existingItem]};
            trackEvent({
              event: 'remove_from_bundle',
              site_section: window.__GLOBAL__.siteSection,
              component_name: 'Bundle Builder Quickview',
              item_name: htmlDecode(deleteItem.title),
              item_id: deleteItem.id,
              currency: window.Shopify.currency.active,
              bundle_id: this.bundleProduct.id,
              bundle_name: this.bundleProduct.title,
              value: deleteItem.price / 100,
              price: deleteItem.price / 100,
              item_list_id: `bundle-step-${step + 1}`,
              item_list_name: this.stepsDecoded[step].title
            })
            this.selectedItems.splice(existingItem, 1);
          }
        });
      },
      showErrorMessage() {
        this.errorMessage = true;
      },
      hideErrorMessage() {
        this.errorMessage = false;
      },
      clearSelection() {
        this.selectedItems = [];
      },
    },
  });
